/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const brandingGenerationErrorSchema = z.enum(['website_unreachable', 'scan_failed'])

export type BrandingGenerationErrorSchema = z.infer<typeof brandingGenerationErrorSchema>
